import {addLoader, apiSlice, asyncToastDisplay, i18n} from "./apiSlice";
import qs from "qs"

const dashboardFilterUrl = (route, filter) => {
  let url = `/dashboard/${route}`
  if (filter) {
    const {startDate, endDate, ...rest} = filter
    url += `?${qs.stringify({date: {start_date: startDate, end_date: endDate}, ...rest}, { arrayFormat: 'brackets' })}`
  }
  return url
}

export const dashboardApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDashboard: builder.query({
      query: ({filter}) => {
        return {
          url: dashboardFilterUrl("", filter)
        }},
      providesTags: (result = [], error, arg) => [{ type: 'Dashboard', id: `kpis:${JSON.stringify(arg)}` } ],
      onQueryStarted: addLoader(),
    }),
    getDashboardDataByDay: builder.query({
      query: ({filter}) => {
        return {
          url: dashboardFilterUrl("data_by_day", filter)
        }},
      providesTags: (result = [], error, arg) => [{ type: 'Dashboard', id: `data_by_day:${JSON.stringify(arg)}` } ],
    }),
    getDashboardDeviceByOs: builder.query({
      query: ({filter}) => {
        return {
          url: dashboardFilterUrl("devices_per_os", filter)
        }},
      providesTags: (result = [], error, arg) => [{ type: 'Dashboard', id: `devices_by_os:${JSON.stringify(arg)}` } ],
    }),
    getDashboardLocationStatus: builder.query({
      query: ({filter}) => ({
          url: dashboardFilterUrl("location_status", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'Dashboard', id: `location_status:${JSON.stringify(arg)}` } ],
    }),
    getDashboardConsents: builder.query({
      query: ({filter}) => ({
          url: dashboardFilterUrl("consents", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'Dashboard', id: `consents:${JSON.stringify(arg)}` } ],
    }),
    getDashboardSdkVersionPerOs: builder.query({
      query: ({filter}) => ({
          url: dashboardFilterUrl("sdk_version_per_os", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'Dashboard', id: `sdk_version_per_os:${JSON.stringify(arg)}` } ],
    }),
    getDashboardOsVersionPerOs: builder.query({
      query: ({filter}) => ({
          url: dashboardFilterUrl("os_version_per_os", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'Dashboard', id: `os_version_per_os:${JSON.stringify(arg)}` } ],
    }),
    getDashboardSdkVersionByDay: builder.query({
      query: ({filter}) => ({
          url: dashboardFilterUrl("sdk_version_by_day", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'Dashboard', id: `sdk_version_by_day:${JSON.stringify(arg)}` } ],
    }),
    getDashboardOsVersionPerDay: builder.query({
      query: ({filter}) => ({
          url: dashboardFilterUrl("os_version_by_day", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'Dashboard', id: `os_version_by_day:${JSON.stringify(arg)}` } ],
    }),
    getDashboardLocationStatusPerOsVersion: builder.query({
      query: ({filter}) => ({
          url: dashboardFilterUrl("location_status_per_os_version", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'Dashboard', id: `location_status_per_os_version:${JSON.stringify(arg)}` } ],
    }),
    getDashboardAps: builder.query({
      query: ({filter}) => ({
          url: dashboardFilterUrl("apps", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'Dashboard', id: `apps:${JSON.stringify(arg)}` } ],
    }),
    getDashboardVersions: builder.query({
      query: ({filter}) => ({
          url: dashboardFilterUrl("versions", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'Dashboard', id: `versions:${JSON.stringify(arg)}` } ],
    }),
  }),
  overrideExisting: false
})

export const {
  useGetDashboardQuery,
  useGetDashboardDataByDayQuery,
  useGetDashboardDeviceByOsQuery,
  useGetDashboardLocationStatusQuery,
  useGetDashboardConsentsQuery,
  useGetDashboardSdkVersionPerOsQuery,
  useGetDashboardOsVersionPerOsQuery,
  useGetDashboardSdkVersionByDayQuery,
  useGetDashboardOsVersionPerDayQuery,
  useGetDashboardLocationStatusPerOsVersionQuery,
  useGetDashboardApsQuery,
  useGetDashboardVersionsQuery
} = dashboardApiSlice
